import React, { useContext } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SelectBox from '../../../../atomic/selectbox/SelectBox';
import { SectionHeader } from '../components/SectionHeader';
import { SectionInfoBanner } from '../components/SectionInfoBanner';
import { StoreTabFooter } from '../components/StoreTabFooter';
import { SS_OUTLINED_INPUT, ssFieldSx, DELIVERY_TYPE_OPTIONS } from '../storeSettingsConstants';
import { GlobalStateDataContext } from '../../../../context-api/data-provider/GlobalStateDataProvider';

export function DeliveryPickupOptions({ meta, form, updateField, tabFooterProps }) {
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const package_plan = onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.package_plan;

  const formatPrice = (raw) => {
    const digitsOnly = raw.replace(/\D/g, '');
    if (digitsOnly.length === 0) return '0.00';
    const padded = digitsOnly.padStart(3, '0');
    const intPart = padded.slice(0, -2);
    const decimalPart = padded.slice(-2);
    return `${parseInt(intPart, 10)}.${decimalPart}`;
  };
  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <SectionInfoBanner title='What this tab controls'>
        <div>Set available order options: delivery, pickup, or both.</div>
      </SectionInfoBanner>

      <div className='store-settings-delivery-row'>
        <div className='store-settings-delivery-type-col'>
          <SelectBox
            sx={{ width: '100%' }}
            label='Ordering options'
            value={form.delivery_type_available}
            onChange={(value) => updateField('delivery_type_available', value)}
            options={DELIVERY_TYPE_OPTIONS.map((o) => o.value)}
            formatOptionLabel={(v) => DELIVERY_TYPE_OPTIONS.find((o) => o.value === v)?.label ?? v}
          />
        </div>
        {package_plan == 'basic' && (
          <div className='store-settings-delivery-fee-col'>
            <TextField
              id='delivery_kitchen_fee'
              className={SS_OUTLINED_INPUT}
              size='small'
              label='Delivery fee'
              value={form.delivery_kitchen_fee}
              onChange={(e) => {
                const input = e.target.value;
                const digitsOnly = input.replace(/\D/g, '');
                if (digitsOnly.length > 5) return; // Prevent long input like "123456"
                const formatted = formatPrice(digitsOnly);
                updateField('delivery_kitchen_fee', formatted);
              }}
              InputProps={{
                startAdornment: <InputAdornment position='start'>$</InputAdornment>,
              }}
              inputProps={{
                inputMode: 'decimal',
                pattern: '^\\d+(\\.\\d{0,2})?$',
              }}
              InputLabelProps={{
                sx: {
                  color: 'gray',
                  '&.Mui-focused': {
                    color: 'rgb(255, 123, 41)',
                  },
                },
              }}
              variant='outlined'
              sx={ssFieldSx}
            />
          </div>
        )}
      </div>

      <StoreTabFooter tabId='6' {...tabFooterProps} />
    </>
  );
}
